import React from "react";
import HomeBanner from '../components/homeBanner/homeBanner';
import KtempleNav from '../components/ktempleNav/ktempleNav';
import Footer from '../components/Footer/Footer';
import VisitingTemple from '../components/VisitingTemple/VisitingTemple';
import DocumentMeta from 'react-document-meta';
import Volunteer from "../components/kvolunteer/kvolunteer";
import Kirtan from "../components/kirtan/kirtan";

function KTVolunteer() {
const meta = {
    title: "Krishna Temple Volunteer - Radha Madhav Krishna Temple",
    description: "Join us in our mission to serve the community and support the Radha Madhav Krishna Temple. Volunteer opportunities available.",
    keywords: "Krishna Temple, Volunteer, Community Service, Radha Madhav Temple, Hindu Temple, Spiritual Service",
  };
  return (
    <div>
      <DocumentMeta {...meta} />
      <KtempleNav />
      <HomeBanner />
      <Volunteer />
      <Kirtan />
      <VisitingTemple />
      <Footer />
    </div>
  )
}

export default KTVolunteer